import React, { useEffect, useState, useContext, useMemo } from 'react'
import { useQuery } from '../../Routing/utils'
import { ScheduleCon, SliderCon, SliderVert, WeekendCon } from './schedStyles'
import { LeagueContext } from '../../Context'
import { AutocompleteContainer } from '../../Components/Search'
import { PageHeader } from '../../Components/Headers'
import { PageContainerMain, Box } from '../../Components/Layout'
import { ScheduleHeader } from './ScheduleHeader'
import { WeekBox, WeekHeader } from './components/weekBox'
import { getBanner, getWeekList } from '../../Utils'
import { mapEventWeeks } from '../../Utils/Events/eventHelpers'
import type { Banner, EventGQL } from '../../Api'
import { Loading } from '../Loading'
import { WeekSlider } from '../../Components/WeekSlider/WeekSlider'
import { SponsorTopBanner } from '../../Components/Layout/sponsorBanners'
import { ListView } from './components/listView/ListView'
import { AdUnit } from '../../Components/Ads/AdUnit'

const Schedule: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { banners, events, eventsLoading } = useContext(LeagueContext)!
  const [selectedWeek, setSelectedWeek] = useState<number>(1)
  const [banner, setBanner] = useState<Banner>(null)
  const [listView, setListView] = useState<boolean>(false)
  let queryParams = useQuery()
  const weekQuery = queryParams && queryParams.get('week')
  const weekQueryNum = weekQuery ? parseInt(weekQuery) : null

  const weeks = useMemo(() => {
    return getWeekList(events)
  }, [events])

  const wkEvents = useMemo(() => {
    if (events.length === 0) return []
    return mapEventWeeks({
      week: selectedWeek.toString(),
      events: events,
    })
  }, [selectedWeek, events])

  useEffect(() => {
    // Set the banner if available
    if (banners.length > 0) {
      const b = getBanner(banners, 'schedule')
      if (b) {
        setBanner(b)
      }
    }

    if (events.length > 0) {
      if (weekQueryNum && weekQueryNum <= weeks.length) {
        setSelectedWeek(weekQueryNum)
      } else {
        // Find the next upcoming event
        const weekRes = events.find((ev) => ev.eventStatus < 2)
        if (!weekRes) {
          return updateByLastGame(events)
        }
        const upcomingWeek = parseInt(weekRes.week)
        setSelectedWeek(upcomingWeek)
      }
    }
  }, [banners, events, weekQueryNum])

  const updateByLastGame = (evs: EventGQL[]) => {
    const lastGame = evs[evs.length - 1]
    if (!lastGame) return
    let lastWk = parseInt(lastGame.week)
    setSelectedWeek(lastWk)
  }

  const handleWeekChange = (wk: string) => {
    const wkNum = parseInt(wk)
    setSelectedWeek(wkNum)
  }

  const onListViewToggle = () => {
    setListView(!listView)
  }

  const requiresET = useMemo(() => {
    const url = window.location.href
    return url.includes('/schedule-et')
  }, [])

  return (
    <PageContainerMain sidePadding={0} fullScreen>
      {banner && !banner.sponsor && (
        <PageHeader img={banner.topUrl} link={banner.topLink} banner={banner} />
      )}
      {banner && banner.sponsor && (
        <SponsorTopBanner img={banner.topUrl} link={banner.topLink} banner={banner} />
      )}
      <AutocompleteContainer />
      <AdUnit bannerType="bannerMain" aria-label="Main advertisement banner" />
      <ScheduleHeader
        page={`Schedule`}
        showListView={listView}
        onViewToggle={onListViewToggle}
      />
      {eventsLoading ? (
        <Box>
          <Loading />
          <AdUnit bannerType="bannerSecond" aria-label="Schedule page ad second" />
        </Box>
      ) : (
        <>
          {events && wkEvents.length > 0 && (
            <>
              {listView ? (
                <ListView events={events} />
              ) : (
                <ScheduleCon>
                  <SliderVert>
                    <WeekSlider
                      weeks={weeks}
                      eventsList={events}
                      currentWeek={selectedWeek.toString()}
                      handleWeekChange={handleWeekChange}
                      page="Schedule"
                      idx={(selectedWeek - 1).toString()}
                      direction={'vertical'}
                    />
                  </SliderVert>
                  <>
                    <SliderCon>
                      <WeekSlider
                        weeks={weeks}
                        eventsList={events}
                        currentWeek={selectedWeek.toString()}
                        page="Schedule"
                        handleWeekChange={handleWeekChange}
                        idx={(selectedWeek - 1).toString()}
                      />
                    </SliderCon>
                    <WeekendCon>
                      <WeekHeader week={selectedWeek.toString()} events={wkEvents} />
                      <WeekBox
                        week={selectedWeek.toString()}
                        events={wkEvents}
                        showInET={requiresET}
                      />
                    </WeekendCon>
                  </>
                </ScheduleCon>
              )}
            </>
          )}
          <AdUnit bannerType="bannerSecond" aria-label="Schedule page ad third" />
        </>
      )}
      {/* <ToggledBottomSlideup
        slideupId="schedule-callout"
        showDelay={1}
        slideDuration={1}
        headerTitle="2025 Schedule Updates"
        component={<TicketInterestForm />}
        showOnLoad={false}
        slideMaxImpressions={1}
        slideWaitPeriod={0}
      /> */}
    </PageContainerMain>
  )
}

export default Schedule
